import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToasterService } from "angular2-toaster";
import { ModalDirective } from "ngx-bootstrap/modal";
import { GenericValidator } from "src/app/_classes/generic.form.validator";
import { EmpresaECentroDestino } from "src/app/_models/empresa-e-centro-destino";
import { EtiquetaMascarello } from "src/app/_models/etiqueta-mascarello";
import { PedidoDeCompra } from "src/app/_models/pedido-de-compra";
import { RegistrarEtiquetaMascarelloDTO } from "src/app/_models/registar-etiqueta-mascarello-dto";
import { LoadingService } from "src/app/_services/local/loading.service";
import { EtiquetasMascarelloService } from "src/app/_services/madu-api/etiquetas-mascarello.service";

@Component({
    selector: 'app-etiquetas-mascarello',
    templateUrl: './etiquetas-mascarello.component.html'
})
export class EtquetasMascarelloComponent implements OnInit {
    @ViewChild('etiquetasModal') public etiquetasModal: ModalDirective;
    @ViewChild('arquivoXML')

    set setarquivoXM(fileInputRef: ElementRef) {
        this.arquivoXML = <HTMLInputElement>fileInputRef.nativeElement;
    };
    private arquivoXML: HTMLInputElement;

    errors: any = [];
    arquivoXMLForm: FormGroup;
    pedidosDeCompra: PedidoDeCompra[];
    paramentroPaginacao: number = 60;
    filtrarPedidosDeComprasForm: FormGroup;
    etiquetasForm: FormGroup;
    private validationMessages: { [key: string]: { [key: string]: string } };
    displayMessage: { [key: string]: string } = {};
    private genericValidator: GenericValidator;
    empresasECentrosDestino: EmpresaECentroDestino[] = [];
    registraEtiquetaDTO: RegistrarEtiquetaMascarelloDTO;
    etiquetasPorPedidoDeCompra: EtiquetaMascarello[] = [];

    etiqueta: EtiquetaMascarello | null = null;
    larguraDaEtiqueta: number | null = null;
    alturaDaEtiqueta: number | null = null;

    constructor(private fb: FormBuilder,
        private toasterService: ToasterService,
        private loadingService: LoadingService,
        private etiquetasMascarelloService: EtiquetasMascarelloService) {

        this.validationMessages = {
            xmlBodyMascarelloId: {
                required: 'xmlBodyMascarelloId é obrigatória.'
            },
            empresaECentroDestinoId: {
                required: 'Planta é obrigatória.'
            },
            numNFe: {
                required: 'A NFe é obrigatório.'
            },
            volume: {
                required: 'A volume é obrigatório.'
            },
            qtd: {
                required: 'A qtd da é obrigatória.'
            }
        };

        this.genericValidator = new GenericValidator(this.validationMessages);

        this.arquivoXMLForm = this.fb.group({
            arquivoXML: ''
        });

        this.filtrarPedidosDeComprasForm = this.fb.group({
            pedidoCompra: '',
            itemPedidoDeCompra: ''
        });

        this.etiquetasForm = this.fb.group({
            xmlBodyMascarelloId: ['', Validators.required],
            empresaECentroDestinoId: ['', Validators.required],
            numNFe: ['', Validators.required],
            volume: ['', Validators.required],
            qtd: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        this.obterPedidosdeVenda();
        this.obterEmpresasECentrosDestino();
    }

    obterEmpresasECentrosDestino() {
        this.etiquetasMascarelloService.getEmpresasECentrosDestino().subscribe(
            result => { this.empresasECentrosDestino = result; },
            error => { this.onError(error); }
        );
    }

    limparFormRegistarXML() {
        this.arquivoXMLForm.reset({
            arquivoXML: ''
        });
    }

    limparFormFiltros() {
        this.filtrarPedidosDeComprasForm.reset({
            pedidoCompra: '',
            itemPedidoDeCompra: ''
        });
    }

    limparFormEtqiuetaExetoXmlBodyMascarelloId() {
        let idXmlAtual = this.etiquetasForm.get('xmlBodyMascarelloId').value;
        this.etiquetasForm.reset({
            xmlBodyMascarelloId: idXmlAtual,
            empresaECentroDestinoId: '',
            numNFe: '',
            volume: '',
            qtd: ''
        });
    }

    limparFormEtqiueta() {
        this.etiquetasForm.reset({
            xmlBodyMascarelloId: '',
            empresaECentroDestinoId: '',
            numNFe: '',
            volume: '',
            qtd: ''
        });
    }

    registrarXML() {

        this.errors = [];

        this.loadingService.showLoading(true);

        console.log(this.arquivoXML);

        if (!this.checarCargaDeArquivoXML(this.arquivoXML)) return;

        this.etiquetasMascarelloService.registrarArquivoXMLMascarello(this.arquivoXML).subscribe(
            result => {
                console.log(result);
                this.toasterService.pop('success', ':)', 'Tudo certo, arquivo XML registrado!');
                this.loadingService.showLoading(false);
                this.obterPedidosdeVenda();
                this.limparFormRegistarXML();
            },
            error => { this.onError(error); });
    }

    exibirEtiquetas(xmlBodyMascarelloId: string) {
        this.errors = [];
        this.limparFormEtqiueta();
        console.log(xmlBodyMascarelloId);
        this.etiquetasForm.get('xmlBodyMascarelloId').setValue(xmlBodyMascarelloId);
        console.log(this.etiquetasForm);
        this.obterEtiquetasRegistradas();
        this.etiquetasModal.show();
    }

    checarCargaDeArquivoXML(imagem: HTMLInputElement): boolean {
        if (imagem.files.length == 0) {
            this.toasterService.pop('error', ':|', 'Selecione uma foto antes de Salvar!!!');
            this.loadingService.showLoading(false);
            return false;
        }
        return true;
    }

    private onError(error) {
        this.loadingService.clearShowLoading();
        console.log(error);
        if (error.errors != null) {
            this.errors = error.errors;
            this.toasterService.pop('error', 'Opa :(', 'Algo deu errado!');
        }
    }

    btnPaginacao() {
        this.paramentroPaginacao += 100;
        this.obterPedidosdeVenda();
    }

    obterPedidosdeVenda() {
        this.loadingService.showLoading(true);
        this.etiquetasMascarelloService.getPedidosDeCompraDisponiveis(this.paramentroPaginacao, this.filtrarPedidosDeComprasForm.value['pedidoCompra'], this.filtrarPedidosDeComprasForm.value['itemPedidoDeCompra'])
            .subscribe(
                result => {
                    console.log(result);
                    this.pedidosDeCompra = result;
                    this.loadingService.showLoading(false);
                },
                error => { this.onError(error); }
            )
    }

    registrarEtiqueta() {
        this.displayMessage = this.genericValidator.processMessages(this.etiquetasForm);
        console.log(this.displayMessage);
        console.log(this.etiquetasForm.value);
        if (this.etiquetasForm.dirty && this.etiquetasForm.valid) {
            let p = Object.assign({}, this.registraEtiquetaDTO, this.etiquetasForm.value)
            console.log(p);
            this.loadingService.showLoading(true);
            this.etiquetasMascarelloService.registrarEtiqueta(p)
                .subscribe(
                    result => {
                        console.log(result);
                        this.toasterService.pop('success', ':)', 'Tudo certo, etiqueta registrada!');
                        this.loadingService.showLoading(false);
                        this.obterEtiquetasRegistradas();
                        this.limparFormEtqiuetaExetoXmlBodyMascarelloId();
                    },
                    error => { this.onError(error) });
        }
    }

    imprimirEtiqueta(etiqueta, largura, altura) {
        this.etiqueta = etiqueta;
        this.larguraDaEtiqueta = largura;
        this.alturaDaEtiqueta = altura;
    }

    fecharModalDaEtiqueta(): void {
        this.etiqueta = null;
        this.larguraDaEtiqueta = null;
        this.alturaDaEtiqueta = null;
    }

    removerEtiqueta(etiqueta) {

    }

    obterEtiquetasRegistradas() {
        this.etiquetasMascarelloService.getEtiquetasPorXMLBodyMascarelloId(this.etiquetasForm.get('xmlBodyMascarelloId').value).subscribe(
            result => { this.etiquetasPorPedidoDeCompra = result; },
            error => { this.onError(error); }
        );
    }
}